
export const productionConfig = {
    depService: `${process.env.VUE_APP_DEP_SERVICE}`,
    dcbService: `${process.env.VUE_APP_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaServiceV2: `${process.env.VUE_APP_TRIVIA_SERVICE_V2}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlob: `${process.env.VUE_APP_AZURE_BLOB}`,
    myMuzeUrl : `${process.env.VUE_APP_MY_MUZE_URL}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    fingerprintPublicKey: `${process.env.VUE_APP_FINGERPRINT_PUBLIC_KEY || ''}`,
    fingerprintRegion: `${process.env.VUE_APP_FINGERPRINT_REGION || 'eu'}`,
    turnstileSiteKey: `${process.env.VUE_APP_TURNSTILE_SITE_KEY || ''}`,
    nodeEnv: `Prod`
}

export const developmentConfig = {
    depService: `${process.env.VUE_APP_DEP_SERVICE}`,
    dcbService: `${process.env.VUE_APP_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaServiceV2: `${process.env.VUE_APP_TRIVIA_SERVICE_V2}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlob: `${process.env.VUE_APP_AZURE_BLOB}`,
    myMuzeUrl : `${process.env.VUE_APP_MY_MUZE_URL}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    fingerprintPublicKey: `${process.env.VUE_APP_FINGERPRINT_PUBLIC_KEY || ''}`,
    fingerprintRegion: `${process.env.VUE_APP_FINGERPRINT_REGION || 'eu'}`,
    turnstileSiteKey: `${process.env.VUE_APP_TURNSTILE_SITE_KEY || ''}`,
    nodeEnv: `Prod`
}

export const stagingConfig = {
    depService: `${process.env.VUE_APP_DEP_SERVICE}`,
    dcbService: `${process.env.VUE_APP_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_STAGING_TRIVIA_SERVICE}`,
    triviaServiceV2: `${process.env.VUE_APP_TRIVIA_SERVICE_V2}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlob: `${process.env.VUE_APP_AZURE_BLOB}`,
    myMuzeUrl : `${process.env.VUE_APP_MY_MUZE_URL}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    fingerprintPublicKey: `${process.env.VUE_APP_FINGERPRINT_PUBLIC_KEY || ''}`,
    fingerprintRegion: `${process.env.VUE_APP_FINGERPRINT_REGION || 'eu'}`,
    turnstileSiteKey: `${process.env.VUE_APP_TURNSTILE_SITE_KEY || ''}`,
    nodeEnv: `Staging`
}

const environment = getEnvironment()

export const environmentConfig = getEnvObject();

function getEnvironment() {
    let base_url = window.location.origin;
    if (base_url.includes('staging')) return 'staging'
    if (base_url.includes('localhost')) return 'development'
    else return 'production'
}

function getEnvObject() {
    if (environment === 'staging') return stagingConfig
    if (environment === 'development') return developmentConfig
    if (environment === 'production') return productionConfig
}
